import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { AssessmentSecondPart, getcriteriaList } from "./PMSService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AddQuestion = ({ submitForm }) => {
  const [criteriaList, setCriteriaList] = useState([]);
  const [questions, setQuestions] = useState([
    {
      Id: 0,
      OrgId: 0,
      TemplatesId: 0,
      CriteriaId: 0,
      Name: "",
      Desc: "",
      Weightage: 0,

      "OATID": 0,
    "MACId": 0,
    "AssessmentPeriodId": 0,
    "CriteriaParameter": "string",
    "CriteriaParameterDesc": "string",
    "MACPId": 0,
    "Weightage": 0
    },
  ]);
  const history = useHistory();

  const addMoreQuestion = () => {
    setQuestions([
      ...questions,
      {
        Id: 0,
        OrgId: 0,
        TemplatesId: 0,
        CriteriaId: 0,
        Name: "",
        Desc: "",
        Weightage: 0,
      },
    ]);
  };

  useEffect(() => {
    getCriteriaMasterList();
  }, []);
  

  async function getCriteriaMasterList() {
    try {
      const response = await getcriteriaList();
      console.log(response.Data);

      setCriteriaList(response.Data);
    } catch (error) {}
  }



  const handleChange = (index, field, value) => {
  setQuestions(prev =>
    prev.map((item, i) =>
      i === index
        ? {
            ...item,
            [field]:
              field === "Weightage" || field === "CriteriaId"
                ? Number(value)
                : value
          }
        : item
    )
  );
};

  async function saveQuestions(value) {
    try {
      // Optional: Remove empty rows
      const filteredQuestions = questions.filter(
        (q) => q.CriteriaId && q.Name && q.Weightage,
      );

      if (filteredQuestions.length === 0) {
        alert("Please add at least one valid question");
        return;
      }

      const params = filteredQuestions;

      console.log("Sending payload:", params);

      const response = await AssessmentSecondPart(params);
      if (value === 1) {
        history.push("/AssessmentCycles");
      } else {
        submitForm("employee");
      }

      console.log("API Response:", response);

      alert("Questions saved successfully!");
    } catch (error) {
      console.error("Error saving questions:", error);
    }
  }

  return (
    <div>
      <div className="flex flex-column h-12rem">
        <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
          <div className="row">
            <div className="col-md-12">
              <div className="add-questions">
                <div className="questionslist-title">
                  <p>No.</p>
                  <p>Criteria</p>
                  <p>Question</p>
                  <p>Weightage %</p>
                </div>

                {questions.map((item, index) => (
                  <div className="questionlist-detail-cols" key={index}>
                    <strong>{index + 1}</strong>

                    {/* <input
                      type="text"
                      className="form-control"
                      value={item.CriteriaId}
                      onChange={(e) =>
                        handleChange(index, "CriteriaId", e.target.value)
                      }
                    /> */}
                    <select
                      className="form-control"
                      value={item.CriteriaId}
                      onChange={(e) =>
                        handleChange(index, "CriteriaId", e.target.value)
                      }
                    >
                      <option value="">Select Criteria</option>
                      {criteriaList.map((criteria) => (
                        <option
                          key={criteria?.Id}
                          value={criteria?.Id}
                        >
                          {criteria?.AssessmentCriteria}
                        </option>
                      ))}
                    </select>

                    <input
                      type="text"
                      className="form-control"
                      value={item.Name}
                      onChange={(e) =>
                        handleChange(index, "Name", e.target.value)
                      }
                    />

                    <input
                      type="number"
                      className="form-control"
                      value={item.Weightage}
                      onChange={(e) =>
                        handleChange(index, "Weightage", e.target.value)
                      }
                    />
                  </div>
                ))}

                <div className="question-add" onClick={() => addMoreQuestion()}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-plus"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                  </svg>
                  Add more question
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex pt-5 justify-content-between text-right">
        <Button
          label="Back"
          severity="secondary"
          className="cancelbutton bg-dark text-white"
          // onClick={() => stepperRef.current.prevCallback()}
        />
        <Button
          label="Save and Exit"
          className="savebutton w-auto"
          onClick={() => saveQuestions(1)}
        />
        <Button
          label="Save and Continue"
          className="publish-click w-auto"
          iconPos="right"
          onClick={() => saveQuestions(2)}
          // onClick={() => stepperRef.current.nextCallback()}
        />
      </div>
    </div>
  );
};

export default AddQuestion;
